<template>
     <el-dialog
  v-model="showVideo"
  destroy-on-close
  width="900px" 
  center
  custom-class="video">
    <iframe width="853" height="480" :src="link" title="YouTube video player" frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; 
    picture-in-picture" allowfullscreen></iframe>
    
    </el-dialog>    
</template>
<script>
import { computed } from 'vue'
import { useStore } from 'vuex'


export default {
    props:['link','tipo'],
    setup(props) {

    const store = useStore()
    const showVideo = computed(() => store.state.showVideo)
    console.log(props)
    return{ showVideo }
    },
}
</script>
<style lang="scss">
    .video{
        background-color: #000D5A !important;
        border-radius: 20px !important;
    }
    @media (max-width:768px) {
        iframe{
            width:100% ;
        }
        .video{
            width: 90% !important;
        }
    }
    @media (max-width:500px) {
        .video{
            width: 100% !important;
        }
    }
</style>